/**
 * @file src/_modulos/prenota/tabela/layouts/tabela/columns/components/status.tsx
 * @description Componentes e funções relacionadas ao status das pré-notas
 */

"use client";

import {
  IconClipboardCheckFilled,
  IconClipboardXFilled,
  IconZoomCheckFilled,
  IconZoomQuestionFilled,
} from "@tabler/icons-react";
import {
  BadgePreset,
  CategoryConfig,
  createIconOnlyPreset,
  createEmptyPreset,
  createInvalidPreset,
} from "./utils";

/**
 * Configuração das categorias de status
 */
const STATUS_CATEGORIES: Record<string, CategoryConfig> = {
  pendente: {
    color: "text-indigo-600 dark:text-indigo-400",
    icon: IconZoomQuestionFilled,
    getTooltip: () => "Status: Pendente – aguardando classificação.",
  },
  classificada: {
    color: "text-lime-600 dark:text-lime-400",
    icon: IconZoomCheckFilled,
    getTooltip: () => "Status: Classificada – processamento concluído.",
  },
  revisar: {
    color: "text-rose-600 dark:text-rose-400",
    icon: IconClipboardXFilled,
    getTooltip: () => "Status: A Revisar – necessita verificação.",
  },
  verificada: {
    color: "text-teal-600 dark:text-teal-400",
    icon: IconClipboardCheckFilled,
    getTooltip: () => "Status: Revisão Verificada – aprovada.",
  },
} as const;

/**
 * Valores válidos para status
 */
const VALID_STATUSES = ["Pendente", "Classificada", "Revisar", "Verificada"];

/**
 * Obtém preset de status
 */
export function getStatusPreset(s?: string | null): BadgePreset {
  const key = s?.trim() ?? "";

  if (!key) {
    return createEmptyPreset(<span>Sem Status</span>, "Status não definido.");
  }

  // Normalizar entrada
  const normalizedKey = key.toLowerCase();
  const categoryKey = normalizedKey as keyof typeof STATUS_CATEGORIES;

  if (!STATUS_CATEGORIES[categoryKey]) {
    return createInvalidPreset(key, VALID_STATUSES, "Inválido");
  }

  const config = STATUS_CATEGORIES[categoryKey];
  return createIconOnlyPreset(config, config.color);
}
